// extracted by mini-css-extract-plugin
module.exports = {"lastSyncedTime":"styles_lastSyncedTime__3C9jM","syncButtonContainer":"styles_syncButtonContainer__34sUj","error":"styles_error__2MuIs"};